<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Receipt & Payment Sheet"
                :customCols="{ leftCol: 12, rightCol: 12 }"
            >
              <template #extra-btn>
                <div class="d-flex flex-wrap gap-75 mt-1 mt-md-0">
                  <button v-if="headId" class="btn btn-success btn-sm flex-grow-1 flex-md-grow-0" @click="openReceiptModal">
                    <i class="fa fa-plus"></i> Receipt
                  </button>
                  <button v-if="headId" class="btn btn-danger btn-sm flex-grow-1 flex-md-grow-0" @click="openPaymentModal">
                    <i class="fa fa-minus"></i> Payment
                  </button>
                  <button v-if="headId" class="btn btn-secondary btn-sm flex-grow-1 flex-md-grow-0" @click="openContraModal">
                    <i class="fa fa-exchange-alt"></i> Transfer
                  </button>
                </div>
              </template>
            </TitleButton>
            <div class="row match-height">
              <div class="col-12 col-lg-12 col-xl-12 col-xxl-12 mt-2">
                <DateQuerySetter
                    @onClickGo="getCustomerStatementData"
                >
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Account Head:</label>
                    <v-select
                        v-model="headId"
                        :options="accountHeads"
                        label="name"
                        placeholder="Select head"
                    />
                  </div>
                </DateQuerySetter>
              </div>
            </div>
        </div>

      <div class="mt-1 px-2">
          <div class="row" v-if="tableItems.length">
            <div class="col-md-4 col-lg-3 col-12 pd-5 py-1">
              <div class="card min-height card-hover-rise bg-opening mb-0">
                <div class="d-flex justify-content-between px-1 pt-1 font-bold">
                  <h5 class="mb-0">Opening Balance</h5>
                </div>
                <hr style="margin:0">
                <div class="card-body p-1">
                  <h4 class="mb-0 font-bold text-left counter-text">
                    {{ commaFormat(ledgerData.opening_balance) }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 col-12 pd-5 py-1">
              <div class="card min-height card-hover-rise bg-debit mb-0">
                <div class="d-flex justify-content-between px-1 pt-1 font-bold">
                  <h5 class="mb-0">Total Receipt</h5>
                </div>
                <hr style="margin:0">
                <div class="card-body p-1">
                  <h4 class="mb-0 font-bold text-left counter-text">
                    {{ commaFormat(ledgerData.total_debit) }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 col-12 pd-5 py-1">
              <div class="card min-height card-hover-rise bg-credit mb-0">
                <div class="d-flex justify-content-between px-1 pt-1 font-bold">
                  <h5 class="mb-0">Total Payment</h5>
                </div>
                <hr style="margin:0">
                <div class="card-body p-1">
                  <h4 class="mb-0 font-bold text-left counter-text">
                    {{ commaFormat(ledgerData.total_credit) }}
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 col-12 pd-5 py-1">
              <div class="card min-height card-hover-rise bg-closing mb-0">
                <div class="d-flex justify-content-between px-1 pt-1 font-bold">
                  <h5 class="mb-0">Closing Balance</h5>
                </div>
                <hr style="margin:0">
                <div class="card-body p-1">
                  <h4 class="mb-0 font-bold text-left counter-text">
                    {{ commaFormat(ledgerData.closing_balance) }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="tableItems.length">
            <div class="d-flex justify-content-end px-2">
              <button
                  @click="goToPrint"
                  class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
              >
                Print
              </button>
              <button
                  @click="exportReport"
                  class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
              >
                Export
              </button>
            </div>
          </div>

          <div class="table-responsive table-striped my-1 border-bottom" style="min-height: 200px">
            <table class="table table-bordered table-sm-responsive">
              <thead class="table-light">
              <tr>
                <th>Date</th>
                <th>Voucher Number</th>
                <th>Account Head</th>
                <th>Description</th>
                <th>Party</th>
                <th class="text-right">Receipts</th>
                <th class="text-right">Payments</th>
                <th class="text-right">Balance</th>
                <th>Attachment</th>
                <th>Status</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="(currentPage === 1 || ((currentPage == undefined) && (currentPage === lastPage)))">
                <td class="text-end" colspan="7"> Opening Balance </td>
                <td class="text-end" colspan="1"> {{ commaFormat(ledgerData.opening_balance) }} </td>
                <td colspan="3"></td>
              </tr>
              <tr v-for="(item ,index) in tableItems" :key="index">
                <td>{{ item.formatted_date }} </td>
                <td>{{ item.voucher_no }}</td>
                <td>
                   <span>
                    <span v-if="isNullOrZero(item.debit)">
                        {{ getFirstAccountHead(item.debit_account_head || '') }}
                         <span v-if="isMultipleAccountHeads(item.debit_account_head)">
                           <button class="btn btn-outline-primary btn-sm"
                                   title="Print voucher"
                                   @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                                   style="cursor: pointer;margin-left: 5px;margin-right: 5px;"
                           >
                             See Details
                          </button>
                        </span>
                    </span>
                     <span v-if="isNullOrZero(item.credit)">
                         {{ getFirstAccountHead(item.credit_account_head || '') }}
                         <span v-if="isMultipleAccountHeads(item.credit_account_head)">
                           <button class="btn btn-outline-primary btn-sm"
                                   title="Print voucher"
                                   @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                                   style="cursor: pointer;margin-left: 5px;margin-right: 5px;"
                           >
                             See Details
                          </button>
                         </span>
                    </span>
                </span>
                </td>
                <td>{{ item.line_description }}</td>
                <td>{{ item.party_name }}</td>
                <td class="text-right">{{ commaFormat(item.debit) }}</td>
                <td class="text-right">{{ commaFormat(item.credit) }}</td>
                <td class="text-right">{{ commaFormat(item.balance) }}</td>
                <td>
                   <span v-if="item.attachments && item.attachments.length > 0" class="cursor-pointer">
                    <button
                        title="View attachment"
                        class="btn btn-outline-secondary btn-sm"
                        style="cursor: pointer"
                        @click="viewAttachments(item.attachments)"
                    >
                      <i class="fas fa-paperclip"></i>

                    </button>
                  </span>
                </td>
                <td>
                  <span class="badge rounded-pill" :class="statusClass(item.master_status)">
                    {{ convertToTitleCase(item.master_status) }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <div class="d-flex justify-content-center gap-75">
                    <button class="btn btn-outline-primary btn-sm"
                            title="Print voucher"
                            @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                            style="cursor: pointer;"
                    >
                      <i class="fas fa-print"></i>
                    </button>

                    <button v-if="item.master_status == 'pending' || item.master_status == 'pending_approval'" class="btn btn-primary btn-sm"
                            style="cursor: pointer"
                            @click="goToEdit(item.ledger_master_id, item.voucher_type)"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="currentPage === lastPage">
                <td class="text-end" colspan="5"> Closing Balance </td>
                <td class="text-end"> {{ commaFormat(ledgerData.total_debit) }}</td>
                <td class="text-end"> {{ commaFormat(ledgerData.total_credit) }}  </td>
                <td class="text-end"> {{ commaFormat(ledgerData.closing_balance) }}</td>
                <td colspan="3"></td>
              </tr>
              </tbody>
            </table>
            <p v-if="!tableItems.length" class="mt-5 text-center">No data</p>
          </div>
        </div>

      <ViewAttachment
          ref="viewAttachmentRef"
          :attachments="modalAttachments"
      />
      <ReceiptModal
          v-if="receiptModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closeReceiptModal"
      />
      <PaymentModal
          v-if="paymentModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closePaymentModal"
      />
      <ContraModal
          v-if="contraModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closeContraModal"
      />
      <div class="px-2">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
      <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {computed, inject, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Loader from "@/components/atom/LoaderComponent.vue";
import handleReport from "@/services/modules/accountingReport";
import figureFormatter from '@/services/utils/figureFormatter'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import pdfPrinter from '@/services/utils/pdf/generalLedger';
import handleCompany from "@/services/modules/company";
import {useStore} from "vuex";
import Pagination from "@/components/atom/Pagination.vue";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'
import { useVoucherPrint } from '@/services/utils/voucherPrint';
import handlePayment from '@/services/modules/payment'
import ReceiptModal from '@/components/molecule/company/receipt-payment/ReceiptModal.vue';
import PaymentModal from '@/components/molecule/company/receipt-payment/PaymentModal.vue';
import ContraModal from '@/components/molecule/company/receipt-payment/ContraModal.vue';
import { convertToTitleCase } from '@/services/utils/global';

const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();
const { fetchCashAndBank } = handlePayment()
const { getLedger } = handleReport();
const route = useRoute()
const router = useRouter();
const store = useStore();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
let offset = ref(25)
const loading = ref(false);
const currentPage = ref(null);
const lastPage = ref(null);
const receiptModalShow = ref(false);
const paymentModalShow = ref(false);
const contraModalShow = ref(false);
const tableItems = ref([])
const ledgerData = ref({
  opening_balance: '0.00',
  total_debit: '0.00',
  total_credit: '0.00',
  closing_balance: '0.00',
})
const accountHeads = ref([])
const headId = ref(null)
const companyInfo = ref(null);
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const {commaFormat} = figureFormatter()

const from = computed(()=> store.state.paginationData.from)
function getQuery () {
    let queryStr = '?company_id=' + route.params.companyId
    queryStr += '&offset=' + offset.value
    if (route.query.page) queryStr += "&page=" + route.query.page;
    if (route.query.start) queryStr += "&start_date=" + route.query.start;
    if (route.query.end) queryStr += "&end_date=" + route.query.end;
    if (headId.value) queryStr += '&headId=' + headId.value.id;
    queryStr += '&include_all_status=1'
    return queryStr
}

function openReceiptModal() {
  receiptModalShow.value = true
}

function closeReceiptModal() {
  receiptModalShow.value = false
}

function openPaymentModal() {
  paymentModalShow.value = true
}

function closePaymentModal() {
  paymentModalShow.value = false
}

function openContraModal() {
  contraModalShow.value = true
}

function closeContraModal() {
  contraModalShow.value = false
}

const isNullOrZero = (value) => {
  return value == null || value === 0 || value === '0.00';
}

const isMultipleAccountHeads = (accountHead) => {
  return accountHead && accountHead.includes(',');
}

const statusClass = (status) => {
  if (!status) return 'badge-light-secondary'
  if (status === 'approved') return 'badge-light-success'
  if (status === 'pending') return 'badge-light-warning'
  if (status === 'rejected') return 'badge-light-danger'
  if (status === 'cancelled') return 'badge-light-danger'
  if (status === 'return') return 'badge-light-danger'
  return 'badge-light-info'
}

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

const { printVoucher, vouchers } = useVoucherPrint();
const goToPrintVoucher = (id, voucherType) => {
  printVoucher(id, voucherType)
}

const goToEdit = (id, type) => {
  const idParam = vouchers[type].idParams;
  const routeName = vouchers[type].route;
  router.push({
    name  : routeName,
    params: {
      companyId: route.params.companyId,
      moduleId : route.params.moduleId,
      menuId   : route.params.menuId,
      pageId   : route.params.pageId,
      [idParam]: id
    },
    query : {
      start: route.query.start,
      end: route.query.end,
      type: 'receipt-payment-sheet'
    }
  })
}

const getFirstAccountHead = (accountHead) => {
  return accountHead ? accountHead.split(',')[0] : '';
}

const getAccountHeads = async () => {
  try {
    loading.value = true;
    let res = await fetchCashAndBank(route.params.companyId);
    if (!res.status) {
      showError(res.message);
    }
    accountHeads.value = res.data;
    headId.value = res.data[0]
  } catch (err) {
    showError("Something is wrong. Check your connectivity!!");
  } finally {
    loading.value = false;
  }
}

const getCustomerStatementData = async () => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  loading.value = true;
  try {
    const res = await getLedger({
      headId: headId.value.id,
      query: getQuery(),
    })

    if (!res.status) {
      tableItems.value = []
      return store.commit("resetPagination")
    }

    tableItems.value = res.data.ledgers.data;
    Object.assign(ledgerData.value, {
      opening_balance: res.data.opening_balance,
      closing_balance: res.data.closing_balance,
      total_debit: res.data.total_debit,
      total_credit: res.data.total_credit,
    })
    currentPage.value = res.data.ledgers.current_page
    lastPage.value = res.data.ledgers.last_page
    if (tableItems.value.length > 0) {
      setPagination(res.data.ledgers)
    }
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getCustomerStatementData()
}

const setPagination = (data) => {
  setPaginationData({
    from: data.from,
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getCompany = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  })
}

const goToPrint = async() => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let ledgerData = {};

  let query = getQuery();
  query += "&is_all=true";

  await getLedger({
    headId: headId.value.id,
    query: query,
  }).then((res) => {
    if (res.status){
      ledgerData = res.data;
      ledgerData.startDate = route.query.start;
      ledgerData.endDate = route.query.end;
      ledgerData.accountName = headId.value ? headId.value.name : ''
      exportToPDF(companyInfo.value, ledgerData, true)
    }
  })
}

onMounted(() => {
  getAccountHeads()
  getCompany();
})

const exportReport = () => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let token = localStorage.getItem('token');
  let url = `${process.env.VUE_APP_BASE_URL}/export/reports/general-ledger/${headId.value.id}${getQuery()}&_token=${token}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}
</script>

<style scoped>
.min-height {
  min-height: 120px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.counter-text {
  font-size: 1.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 576px) {
  .counter-text {
    font-size: 1.5rem;
  }
  .min-height {
    min-height: 100px;
  }
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
.bg-opening{
  background-color: rgba(0, 207, 232, 0.12);
}
.bg-closing{
  background-color: rgb(252, 234, 234);;
}
.bg-credit{
  background-color: rgba(40, 199, 111, 0.12);;
}
.bg-debit{
  background-color: rgb(238, 237, 253);;
}
@media (max-width: 576px) {
  .table-sm-responsive {
    font-size: 11px;
  }
  .table-sm-responsive th, .table-sm-responsive td {
    padding: 0.5rem 0.25rem !important;
  }
}
</style>